import React from 'react';
import { Text } from '@fragments';
import { IconCheck, IconMinus, IconSparkles } from '@tabler/icons-react';
import PlanName from '../PlanName';
import './styles.scss';

// One plan in the comparison: name, pitch, price, its action, then the rows every card
// shares (side by side, a subgrid keeps those parts level across cards). `featured` is
// the plan the Studio steers to: animated AI border, glows and a "recommended" badge.
export default function PlanCard({ plan, name, tagline, price, period, badge, featured, current, action, rows, t }) {
  return <article className={`studio-plan-card${featured ? ' is-featured' : ''}${current ? ' is-current' : ''}`} aria-labelledby={`studio-plan-card-${plan}`} data-plan={plan}>
    {featured && <span className="studio-plan-card__fx" aria-hidden="true"><i className="is-violet" /><i className="is-cool" /><i className="is-warm" /></span>}
    <div className="studio-plan-card__head">
      <Text.h4 id={`studio-plan-card-${plan}`} contrast={10} weight={500}><PlanName>{name}</PlanName></Text.h4>
      {badge && <span className="studio-plan-card__badge">{featured && !current && <IconSparkles aria-hidden="true" />}<Text.caption contrast={9} weight={500}>{badge}</Text.caption></span>}
    </div>
    <Text.p contrast={7} className="studio-plan-card__tagline">{tagline}</Text.p>
    <div className="studio-plan-card__price">
      <Text.h3 contrast={10} weight={500}>{price}</Text.h3>
      <Text.span contrast={6}>{period}</Text.span>
    </div>
    {action && <div className="studio-plan-card__action">{action}</div>}
    <ul className="studio-plan-card__rows">
      {rows.map(row => <li key={row.key} className={row.included ? '' : 'is-missing'}>
        {row.included ? <IconCheck aria-hidden="true" /> : <IconMinus aria-hidden="true" />}
        <Text.span contrast={row.included ? 8 : 5}>{row.label}{!row.included && <span className="studio-visually-hidden"> ({t('planNotIncluded')})</span>}</Text.span>
        {row.soon && <Text.caption contrast={5}>{t('soon')}</Text.caption>}
      </li>)}
    </ul>
  </article>;
}
